<style lang="scss"></style>

<template>
  <div class="popup">
    <div class="popup-header">
      <p class="mb-0 fs-17 fw-b">
        <i class="fal fa-trash mr-8"></i>
        {{ $t(`${$options.name}.${type}_title`) }}
      </p>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="popup-content fs-17">
      <i18n :path="`${$options.name}.${type}_description`">
        <strong>"{{ modelTitle }}"</strong>
      </i18n>
    </div>
    <div class="popup-footer">
      <span class="btn btn-outline-primary ml-auto" @click="$emit('close')">{{ $t('general.cancel') }}</span>
      <div class="btn btn-primary ml-15" @click="remove">{{ $t('general.remove') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popups.general.remove',

  props: {
    modelTitle: {
      type: String,
      required: true,
    },
    modelId: {
      type: Number,
      required: true,
      validator: function(value) {
        return value > 0;
      },
    },
    objectId: {
      type: Number,
      required: false,
    },
    answerId: {
      type: Number,
      required: false,
    },
    type: {
      type: String,
      required: true,
      validator: function(value) {
        return ['object', 'container', 'file', 'template', 'objectTemplate', 'templateAnswer', 'libraryFile'].indexOf(value) !== -1;
      },
    },
    onSuccess: {
      type: Function,
      required: false,
    },
  },

  methods: {
    remove() {
      let url = `${this.type}/delete`;
      let data = this.modelId;
      if (this.type === 'objectTemplate') {
        url = 'object/deleteTemplate';
        data = { objectId: this.objectId, templateId: this.modelId };
      }
      if (this.type === 'templateAnswer') {
        url = 'template/deleteTemplateAnswer';
        data = { objectId: this.objectId, answerId: this.answerId, templateId: this.modelId };
      }

      this.$store.dispatch(url, data).then((res) => {
        if (this.onSuccess) this.onSuccess(res);

        this.$emit('close');
      });
    },
  },
};
</script>
